import React from 'react';
import { HiBriefcase } from 'react-icons/hi';

const WhatWeDo = () => {
  const cards = [
    {
      id: 1,
      image:
        'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800&h=600&fit=crop',
      heading: 'Fuel demand with spec ads',
      description:
        'Create personalized spec ads that open doors before the first call. Our AI-generated cinematic content showcases your product in action, tailored to each prospect industry and brand—turning cold outreach into warm conversations with ready-to-close deals',
      buttonText: 'For Sales',
    },
    {
      id: 2,
      image:
        'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop',
      heading: 'Scale creative production',
      description:
        'Deliver broadcast-quality video ads in hours, not weeks. Our AI platform produces cinematic, high-detail content without traditional production costs or crews. Test more concepts, iterate faster, and scale your creative output 10x while maintaining premium quality.',
      buttonText: 'For Creatives',
    },
    {
      id: 3,
      image:
        'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop',
      heading: 'Empower advertisers instantly',
      description:
        'Integrate AI-powered video creation directly into your platform. Give your clients instant access to cinematic ad content—no agencies, no wait times. Boost platform value, reduce churn, and unlock new revenue with seamless, white-label video generation.',
      buttonText: 'For Tech',
    },
  ];

  return (
    <section className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden bg-white">
      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="flex items-center justify-center gap-2 mb-4">
          <HiBriefcase className="text-brand" />
          <span className="text-brand text-sm font-semibold tracking-widest">
            WHAT WE DO
          </span>
        </div>

        <h2 className="text-4xl md:text-5xl xl:text-6xl font-extrabold text-ink text-center mb-6">
          Unlock the Power of <br />
          <span className="text-brand">Video Ad Creative at Scale</span>
        </h2>

        <p className="text-ink-muted text-lg text-center max-w-4xl mx-auto mb-16">
          From spec ad sales to broadcast-quality video production and seamless
          platform integrations — Autometa Studio turns creativity into growth.
        </p>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cards.map((card) => (
            <div
              key={card.id}
              className="group overflow-hidden
                         hover:border-brand hover:border-2
                         hover:shadow-xl hover:shadow-brand/20
                         hover:-translate-y-2
                         transition-all duration-300 ease-out
                         shadow-lg relative z-10
                         bg-white border border-black/8 rounded-3xl
                         cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden rounded-t-3xl">
                <img
                  src={card.image}
                  alt={card.heading}
                  className="w-full h-full object-cover grayscale-[0.2] group-hover:grayscale-0
                             transition-all duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent
                              group-hover:from-black/10 transition-all duration-300"></div>
              </div>

              {/* Content */}
              <div className="p-8 flex flex-col h-full relative z-10 text-center bg-white">
                <h3 className="text-xl md:text-1xl font-bold text-ink mb-4 leading-snug
                              group-hover:text-brand transition-colors duration-300">
                  {card.heading}
                </h3>

                <p className="text-ink-muted text-sm leading-relaxed mb-8
                             transition-colors duration-300">
                  {card.description}
                </p>

                <button
                  className="group/btn mt-auto inline-flex items-center justify-center
                             text-brand border-2 border-brand/60
                             group-hover:bg-brand group-hover:text-white
                             group-hover:border-brand group-hover:scale-105
                             px-6 py-3 rounded-lg font-semibold
                             transition-all duration-300 ease-out"
                >
                  {card.buttonText}
                  <span className="ml-2 transition-transform duration-300 group-hover/btn:translate-x-1">
                    →
                  </span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
